import React from "react";
import { useParams, Link } from "react-router-dom";
import { PageHero, Section } from "@/components/Editorial";

const LEGAL = {
  terms: {
    title: "Terms of Use",
    paragraphs: [
      "This website is operated by Hema Connoisseur Collections (P) Limited for corporate, trade and portfolio information purposes. By accessing it, you confirm that you are of legal drinking age in your jurisdiction and agree to use the content for lawful, professional purposes.",
      "Content on this site — including text, layout and imagery — may not be reproduced or redistributed without written consent. Product and producer names referenced remain the property of their respective owners.",
      "Information presented here is descriptive of HCC's corporate activities and does not constitute an offer for sale to consumers. Trade terms are agreed separately through formal documentation.",
      "HCC may update this website and these terms from time to time without prior notice.",
    ],
  },
  privacy: {
    title: "Privacy Policy",
    paragraphs: [
      "HCC respects the privacy of its trade partners and website visitors. This website collects only the information necessary to operate — such as an age-verification preference stored in your browser.",
      "When enquiry forms are introduced, information submitted will be used solely to respond to your enquiry and manage trade relationships. We do not sell or share personal information with third parties for marketing purposes.",
      "For questions regarding data held about you or your organisation, please reach our team through the Contact page.",
    ],
  },
  cookies: {
    title: "Cookie Policy",
    paragraphs: [
      "This website uses minimal browser storage. An age-verification preference is retained locally so returning visitors are not asked repeatedly.",
      "No advertising or cross-site tracking cookies are used. Any analytics introduced in future will be disclosed on this page.",
      "You may clear your browser storage at any time, after which the age-verification notice will appear again.",
    ],
  },
  "responsible-communication": {
    title: "Responsible Communication",
    paragraphs: [
      "Hema Connoisseur Collections presents alcoholic beverage information for corporate and trade purposes only. Our communication is factual, restrained and directed at professional audiences.",
      "Nothing on this website is intended to encourage excessive consumption or to address persons below legal drinking age in their jurisdiction.",
      "We expect the same standard of responsible presentation from partners representing our portfolio in market.",
    ],
  },
};

export default function LegalPage() {
  const { slug } = useParams();
  const page = LEGAL[slug];

  if (!page) {
    return (
      <div className="bg-[#F7F1E7] min-h-[60vh]">
        <PageHero eyebrow="Legal" title="Page not found." lede="The legal document you requested does not exist." />
        <Section>
          <Link to="/" className="text-[11px] uppercase tracking-[0.2em] text-[#4B0F1E] border-b border-[#C7A45D] pb-1">
            Return home →
          </Link>
        </Section>
      </div>
    );
  }

  return (
    <div data-testid={`legal-page-${slug}`} className="bg-[#F7F1E7]">
      <PageHero eyebrow="Legal" title={page.title} />
      <Section className="pt-0">
        <div className="max-w-2xl space-y-5">
          {page.paragraphs.map((p, i) => (
            <p key={i} className="text-sm font-light leading-relaxed text-[#1c1713]/70">
              {p}
            </p>
          ))}
        </div>
      </Section>
    </div>
  );
}
